import { CardComponentProps } from "@~/types/types";
import styles from "./HeroAttributes.module.scss";
import classNames from "classnames";
import { AttributeFull } from "@~/types/prodcatBaseTypes";

export function HeroAttributes({
  product,
}: Pick<CardComponentProps, "product">) {
  const transformHeroAttributes = (
    attributes: AttributeFull[],
  ): AttributeFull[] | undefined => {
    const heroAttributes = attributes
      ?.filter(
        (attribute) => attribute.heroRanking || attribute.heroRanking === 0,
      )
      .sort((a, b) => (a.heroRanking || 0) - (b.heroRanking || 0));
    if (!heroAttributes || heroAttributes?.length <= 1) {
      return undefined;
    }
    return heroAttributes.slice(0, 4).map((attribute) => ({
      heroRanking: attribute.heroRanking,
      values: attribute.values?.slice(0, 1),
      displayName: attribute.displayName,
      key: attribute.key,
    }));
  };

  const heroAttributes: AttributeFull[] =
    (product?.attributes && transformHeroAttributes(product?.attributes)) || [];

  if (heroAttributes.length === 0) {
    return null;
  }

  return (
    <ul
      className={classNames(styles["hero-attributes"])}
      data-testid="hero-attributes"
    >
      {heroAttributes.map((attr) => (
        <li
          key={`hero-${attr.key}}`}
          className={classNames(styles["hero-attributes__attr"])}
        >
          <strong className={classNames(styles["hero-attributes__attr-title"])}>
            {attr.displayName}:{" "}
          </strong>
          {attr.values.join(",\u00a0")}
        </li>
      ))}
    </ul>
  );
}
